// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import Vue from 'vue'
import App from './App'
import router from './router'
import VueCookies from 'vue-cookies'
import toast from './toast/index'
import svg from 'svg-progress-bar'





Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueCookies)
Vue.use(toast)
Vue.use(svg,{componentName: 'svg-bar'})

/* eslint-disable no-new */
const globalRouter = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

export default globalRouter



// WEBPACK FOOTER //
// ./src/main.js